/* eslint-disable import/no-anonymous-default-export */
import { HighlightedResourceList } from './list/HighlightedResourceList';
import { HighlightedResourceLight, HighlightedResourceSummary } from '@wwf/sdk';

export default {
    list: HighlightedResourceList,
    recordRepresentation: (
        record: HighlightedResourceSummary | HighlightedResourceLight
    ) => record.name ?? record.url ?? `${record.id}`,
};
